import { Button, Eyebrow, Headline, Image, Markdown } from '../../snippets';
import { Schema } from './ImageWithTextLanding.schema';

export function ImageWithTextLanding({ cms }) {
  const {
    eyebrow,
    heading,
    image,
    imageAlignment,
    eyebrowIconImage,
    alignTextWithImage,
    topPadding,
    bottomPadding,
    content,
    buttonLink,
    darkMode,
    mobileImage,
  } = cms;

  return (
    <section className={darkMode ? 'dark' : ''}>
      <div
        className={`dark:bg-[#202635] dark:text-white ${
          topPadding ? 'pt-[25px]' : 'md:pt-[0px]'
        } ${bottomPadding ? 'pb-[55px]' : 'md:pb-[0px]'}`}
      >
        <div
          className={[
            'px-contained } mx-auto max-w-[var(--content-max-width)] pb-[0px] max-md:pt-[25px] md:pb-[25px] md:pt-[50px]',
          ].join(' ')}
        >
          <div className="unique-technology grid grid-cols-1 lg:grid-cols-2">
            <div
              className={`content-column ${
                alignTextWithImage && imageAlignment === 'right'
                  ? 'lg:justify-end lg:text-right'
                  : ''
              } :order-1 order-1 flex items-center border-t border-t-[#FFFFFF33] p-4 py-[60px] max-lg:px-[0px] max-lg:pb-[25px] max-lg:pt-[10px] lg:border-t-0 lg:px-[50px] ${
                imageAlignment === 'left' ? 'order-1' : 'order-0'
              }`}
            >
              <div>
                <div
                  className={`inline-flex items-center ${
                    imageAlignment === 'right'
                      ? 'lg:flex-row-reverse'
                      : 'flex-row'
                  }`}
                >
                  {eyebrowIconImage && (
                    <Image
                      className="mx-auto max-sm:w-[18px]"
                      sizes="48px"
                      width="24px"
                      height="24px"
                      src={eyebrowIconImage.src}
                    />
                  )}
                  {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                </div>
                {heading && (
                  <Headline
                    variant="h3"
                    element="h2"
                    className="mb-[10px] max-md:text-[22px]"
                  >
                    {heading}
                  </Headline>
                )}

                {content && (
                  <div className="text-[14px] sm:text-[18px] [&_p:not(:first-child)_strong]:border-t [&_p:not(:first-child)_strong]:border-t-[#FFFFFF33] [&_p:not(:first-child)_strong]:pt-6 [&_strong]:mt-6 [&_strong]:block [&_strong]:text-[16px]">
                    <Markdown>{content}</Markdown>
                  </div>
                )}

                {buttonLink && (
                  <div className="mt-6">
                    <Button
                      href={buttonLink?.url}
                      theme="primary"
                      variant="filled"
                    >
                      {buttonLink?.text}
                    </Button>
                  </div>
                )}
              </div>
            </div>

            {(image || mobileImage) && (
              <div
                className={`image-column  order-0 relative block h-[276px] w-full py-6 lg:h-[600px] ${
                  imageAlignment === 'left' ? 'lg:order-0' : 'lg:order-1'
                }`}
              >
                <Image
                  src={mobileImage ? mobileImage.src : image?.src}
                  alt={heading}
                  fill
                  className="block lg:hidden"
                />
                <Image
                  src={image?.src}
                  alt={heading}
                  fill
                  className="hidden lg:block"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

ImageWithTextLanding.displayName = 'Image With Text Landing';
ImageWithTextLanding.Schema = Schema;
